// extracted by mini-css-extract-plugin
module.exports = {"small":"DisplaySectionSmall_small__T5URW"};